import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { isArray } from 'lodash';
import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestOperacaoAbastecimentoExterno({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'amaggisabastecimentosexternos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* deleteOperacaoAbastecimentoExterno({ payload }) {
  try {
    const { params, query } = payload;

    yield call(api.put, `amaggisabastecimentosexternos/cancela`, params);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* store({ payload }) {
  try {
    const { operacaoabastecimentoexterno, params } = payload;

    yield call(
      api.post,
      'amaggisabastecimentosexternos',
      operacaoabastecimentoexterno
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/abastecimentosexternos');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* find({ payload }) {
  try {
    const { idoperacaoabastecimentoexterno } = payload;

    const { data } = yield call(
      api.get,
      `amaggisabastecimentosexternos/${idoperacaoabastecimentoexterno}`
    );

    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* update({ payload }) {
  try {
    const { notaAtualizada, params } = payload;

    yield call(api.put, 'amaggisabastecimentosexternos', notaAtualizada);
    yield put(successRemove({ ...params, pesquisalista: true }));

    history.push('/amaggisabastecimentosexternos');

    toast.success(t('s.geral.sucessoalteracao'));
  } catch (erros) {
    yield put(failedRequest());

    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'amaggisabastecimentosexternos', {
      params,
      paramsSerializer: (params) => qs.stringify(params),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export default all([
  takeLatest(
    '@operacaoabastecimentoexterno/OPERACAOABASTECIMENTOEXTERNO_IN_REQUEST',
    requestOperacaoAbastecimentoExterno
  ),
  takeLatest(
    '@operacaoabastecimentoexterno/DELETE_OPERACAOABASTECIMENTOEXTERNO',
    deleteOperacaoAbastecimentoExterno
  ),
  takeLatest(
    '@operacaoabastecimentoexterno/SUCCESS_REMOVE',
    requestOperacaoAbastecimentoExterno
  ),
  takeLatest(
    '@operacaoabastecimentoexterno/STORE_OPERACAOABASTECIMENTOEXTERNO',
    store
  ),
  takeLatest(
    '@operacaoabastecimentoexterno/FIND_OPERACAOABASTECIMENTOEXTERNO',
    find
  ),
  takeLatest(
    '@operacaoabastecimentoexterno/UPDATE_OPERACAOABASTECIMENTOEXTERNO',
    update
  ),
  takeLatest('@operacaoabastecimentoexterno/RECORD_FILTERING', applyedFilters),
]);
